module.exports = __webpack_public_path__ + "static/train-success-2b8555779128a42b69b938a6c5b58f23.gif";